export const SPECIAL_ROLES = {
  MASTER: 'master',
  ADMIN: 'admin',
};

export const PERMISSION_ELEMENTS = {
  'DASHBOARD.STATS.VIEW': 'Ver Dashboard',
  'ROOMS.VIEW': 'Ver Habitaciones',
  'ROOMS.EXISTING.VIEW': 'Ver Habitaciones Existentes',
  'ROOMS.EXISTING.FILTER': 'Filtrar Habitaciones',
  'ROOMS.EXISTING.EXPORT': 'Exportar Habitaciones',
  'ROOMS.EXISTING.PRINT': 'Imprimir Habitaciones',
  'ROOMS.EXISTING.IMPORT': 'Importar Habitaciones',
  'ROOMS.EXISTING.DELETE': 'Eliminar Habitaciones',
  'ROOMS.EXISTING.DETAIL': 'Ver Detalles de Habitaciones',
  'ROOMS.REGISTER.CREATE': 'Crear Habitación',
  'ROOMS.REGISTER.FILL_FORM': 'Llenar Formulario de Habitación',
  'ROOMS.DETAIL.VIEW': 'Ver Detalles de Habitación',
  'ROOMS.DELETE': 'Eliminar Habitación',
  'ROOMS.FILTER': 'Filtrar Habitaciones',
  'ROOMS.EXPORT': 'Exportar Habitaciones',
  'INVENTORY.STOCK.VIEW': 'Ver Inventario',
  'INVENTORY.STOCK.FILTER': 'Filtrar Inventario',
  'INVENTORY.STOCK.EXPORT': 'Exportar Inventario',
  'INVENTORY.STOCK.ENTRY': 'Entrada de Inventario',
  'INVENTORY.STOCK.ADJUST': 'Ajuste de Inventario',
  'INVENTORY.STOCK.PHYSICAL': 'Inventario Físico',

  'INVENTORY.PURCHASE_ORDERS.VIEW': 'Ver Órdenes de Compra',
  'INVENTORY.PURCHASE_ORDERS.CREATE': 'Crear Órdenes de Compra',
  'INVENTORY.PURCHASE_ORDERS.FILTER': 'Filtrar Órdenes de Compra',
  'INVENTORY.PURCHASE_ORDERS.SEND': 'Enviar Órdenes de Compra',

  'INVENTORY.PRODUCTS.VIEW': 'Ver Productos',
  'INVENTORY.PRODUCTS.CREATE': 'Crear Productos',
  'INVENTORY.PRODUCTS.FILTER': 'Filtrar Productos',
  'INVENTORY.PRODUCTS.EXPORT': 'Exportar Productos',

  'INVENTORY.PROVIDERS.VIEW': 'Ver Proveedores',
  'INVENTORY.PROVIDERS.CREATE': 'Crear Proveedores',
  'INVENTORY.PROVIDERS.EDIT': 'Editar Proveedores',
  'INVENTORY.PROVIDERS.DELETE': 'Eliminar Proveedores',
  'INVENTORY.PROVIDERS.FILTER': 'Filtrar Proveedores',
  'INVENTORY.PROVIDERS.ASSIGNPRODUCTS': 'Asignar Productos a Proveedores',

  'INVENTORY.WAREHOUSES.VIEW': 'Ver Almacenes',
  'INVENTORY.WAREHOUSES.CREATE': 'Crear Almacenes',
  'INVENTORY.WAREHOUSES.EDIT': 'Editar Almacenes',
  'INVENTORY.WAREHOUSES.DELETE': 'Eliminar Almacenes',

  'INVENTORY.CATEGORIES.VIEW': 'Ver Categorías',
  'INVENTORY.CATEGORIES.CREATE': 'Crear Categorías',
  'INVENTORY.CATEGORIES.DELETE': 'Eliminar Categorías',
  'INVENTORY.CATEGORIES.FILTER': 'Filtrar Categorías',
  'INVENTORY.CATEGORIES.DETAILS': 'Ver Detalles de Categorías',

  'INVENTORY.DISPATCH.VIEW': 'Ver Despachos',
  'INVENTORY.DISPATCH.EXECUTE': 'Ejecutar Despachos',
  'INVENTORY.DISPATCH.BY_SEQUENCE': 'Despacho por Secuencia',
  'INVENTORY.DISPATCH.BY_ORDER': 'Despacho por Orden',

  'INVENTORY.REQUISITION.CREATE': 'Crear Requisiciones',
  'INVENTORY.REQUISITION.SEND': 'Enviar Requisiciones',

  'INVENTORY.ORDERS.VIEW': 'Ver Órdenes Médicas',
  'INVENTORY.ORDERS.FILTER': 'Filtrar Órdenes Médicas',
  'CATALOG.MEDICAL_SERVICES.VIEW': 'Ver Servicios Médicos',
  'CATALOG.MEDICAL_SERVICES.CREATE': 'Crear Servicios Médicos',
  'CATALOG.MEDICAL_SERVICES.EDIT': 'Editar Servicios Médicos',
  'CATALOG.MEDICAL_SERVICES.DELETE': 'Eliminar Servicios Médicos',
  'CATALOG.MEDICAL_SERVICES.FILTER': 'Filtrar Servicios Médicos',

  'MEDICAL_SERVICES.REQUESTS.VIEW': 'Ver Solicitudes de Servicios Médicos',
  'MEDICAL_SERVICES.REQUESTS.FILTER': 'Filtrar Solicitudes de Servicios Médicos',
  'APPOINTMENTS.CALENDAR.VIEW': 'Ver Calendario de Citas',
  'APPOINTMENTS.CALENDAR.CREATE': 'Crear Citas',
  'APPOINTMENTS.CALENDAR.NAVIGATE': 'Navegar Calendario de Citas',
  'BILLING.INVOICES.VIEW': 'Ver Facturas',
  'BILLING.INVOICES.CREATE': 'Crear Facturas',
  'BILLING.INVOICES.EDIT': 'Editar Facturas',
  'BILLING.INVOICES.FILTER': 'Filtrar Facturas',
  'BILLING.INVOICES.DETAIL': 'Ver Detalles de Facturas',

  'BILLING.INVOICE_DETAIL.CREATE_AND_SEND': 'Crear y Enviar Factura',
  'BILLING.INVOICE_DETAIL.ADD_ITEM': 'Agregar Item a Factura',
  'BILLING.INVOICE_DETAIL.REMOVE_ITEM': 'Remover Item de Factura',
  'BILLING.INVOICE_DETAIL.EDIT_STATUS': 'Editar Estado de Factura',
  'BILLING.INVOICE_DETAIL.EDIT_TO': 'Editar Información Para',
  'BILLING.INVOICE_DETAIL.EDIT_FROM': 'Editar Información De',
  'BILLING.INVOICE_DETAIL.SET_DATES': 'Establecer Fechas',
  'BILLING.INVOICE_DETAIL.CALCULATE_TOTALS': 'Calcular Totales',
  'BILLING.INVOICE_DETAIL.SAVE_DRAFT': 'Guardar Borrador',
  'ACCOUNTING.ACCOUNTS.VIEW': 'Ver Cuentas',
  'ACCOUNTING.ACCOUNTS.CREATE': 'Crear Cuentas',
  'ACCOUNTING.ACCOUNTS.FILTER': 'Filtrar Cuentas',
  'ACCOUNTING.ACCOUNTS.EXPAND': 'Expandir Detalles de Cuentas',

  'ACCOUNTING.ENTRIES.VIEW': 'Ver Asientos Contables',
  'ACCOUNTING.ENTRIES.CREATE': 'Crear Asientos Contables',
  'ACCOUNTING.ENTRIES.FILTER': 'Filtrar Asientos Contables',
  'ACCOUNTING.ENTRIES.EXPAND': 'Expandir Asientos Contables',

  'ACCOUNTING.CHECKS.VIEW': 'Ver Cheques',
  'ACCOUNTING.CHECKS.CREATE': 'Crear Cheques',
  'ACCOUNTING.CHECKS.DELETE': 'Eliminar Cheques',
  'ACCOUNTING.CHECKS.FILTER': 'Filtrar Cheques',

  'ACCOUNTING.FIXED_ASSETS.VIEW': 'Ver Activos Fijos',
  'ACCOUNTING.FIXED_ASSETS.CREATE': 'Crear Activos Fijos',
  'ACCOUNTING.FIXED_ASSETS.FILTER': 'Filtrar Activos Fijos',

  'ACCOUNTING.POS.VIEW': 'Ver Punto de Venta',
  'ACCOUNTING.POS.INIT_SHIFT': 'Iniciar Turno',
  'ACCOUNTING.POS.CLOSE_SHIFT': 'Cerrar Turno',
  'ACCOUNTING.POS.SEARCH_ITEM': 'Buscar Item',
  'ACCOUNTING.POS.SELECT_BILL_TYPE': 'Seleccionar Tipo de Factura',
  'ACCOUNTING.POS.PROCESS_PAYMENT': 'Procesar Pago',
  'ACCOUNTING.POS.PROCESS_FINAL_PAYMENT': 'Procesar Pago Final',
  'ACCOUNTING.POS.EDIT_SUMMARY': 'Editar Resumen de Pago',
  'EMPLOYEES.LIST.VIEW': 'Ver Empleados',
  'EMPLOYEES.LIST.CREATE': 'Crear Empleados',
  'EMPLOYEES.LIST.FILTER': 'Filtrar Empleados',

  'EMPLOYEES.CREATE.VIEW': 'Ver Formulario de Empleados',
  'EMPLOYEES.CREATE.SUBMIT': 'Enviar Formulario de Empleados',
  'EMPLOYEES.CREATE.UPLOAD_ID': 'Subir Documento de Empleados',

  'EMPLOYEES.DEPARTMENTS.VIEW': 'Ver Departamentos',
  'EMPLOYEES.DEPARTMENTS.CREATE': 'Crear Departamentos',
  'EMPLOYEES.DEPARTMENTS.FILTER': 'Filtrar Departamentos',
  'EMPLOYEES.DEPARTMENTS.EXPORT': 'Exportar Departamentos',
  'RECURSOS_HUMANOS.VACANTES.VIEW': 'Ver Vacantes',
  'RECURSOS_HUMANOS.VACANTES.CREATE': 'Crear Vacantes',
  'RECURSOS_HUMANOS.VACANTES.CREATE.ACCESS': 'Acceder a Creación de Vacantes',
  'RECURSOS_HUMANOS.VACANTES.CREATE.NAME': 'Escribir Nombre de Vacante',
  'RECURSOS_HUMANOS.VACANTES.CREATE.DESCRIPTION': 'Editar Descripción de Vacante',
  'RECURSOS_HUMANOS.VACANTES.CREATE.RESPONSABILITIES': 'Agregar Responsabilidades',
  'RECURSOS_HUMANOS.VACANTES.CREATE.SKILLS': 'Agregar Habilidades Requeridas',
  'RECURSOS_HUMANOS.VACANTES.FILTER': 'Filtrar Vacantes',
  'RECURSOS_HUMANOS.VACANTES.SORT': 'Ordenar Vacantes',

  'RECURSOS_HUMANOS.SOLICITUDES.VIEW': 'Ver Solicitudes de Empleados',
  'RECURSOS_HUMANOS.SOLICITUDES.FILTER': 'Filtrar Solicitudes',
  'RECURSOS_HUMANOS.SOLICITUDES.EXPORT': 'Exportar Solicitudes',
  'RECURSOS_HUMANOS.SOLICITUDES.STATE_ACCESS': 'Acceder a Estados de Solicitudes',
  'NURSING.SHIFTS.START_SHIFT': 'Iniciar Turno de Enfermería',

  'NURSING.PRODUCT_REQUEST.VIEW': 'Ver Solicitudes de Productos',
  'NURSING.PRODUCT_REQUEST.CREATE': 'Crear Solicitudes de Productos',
  'NURSING.PRODUCT_REQUEST.FILTER': 'Filtrar Solicitudes de Productos',

  'NURSING.PRODUCT_REQUEST_MODAL.SELECT_PRODUCT': 'Seleccionar Producto',
  'NURSING.PRODUCT_REQUEST_MODAL.ADD_ITEM': 'Agregar Item',
  'NURSING.PRODUCT_REQUEST_MODAL.SUBMIT_REQUEST': 'Enviar Solicitud',
  'NURSING.PRODUCT_REQUEST_MODAL.CANCEL': 'Cancelar Solicitud',
  'SEGUROS.PROVEEDORES.VIEW': 'Ver Proveedores de Seguros',
  'SEGUROS.PROVEEDORES.CREATE': 'Crear Proveedores de Seguros',
  'SEGUROS.PROVEEDORES.EDIT': 'Editar Proveedores de Seguros',
  'SEGUROS.PROVEEDORES.FILTER': 'Filtrar Proveedores de Seguros',

  'ASEGURADORAS.AUDITORIA.VIEW': 'Ver Auditoría de Seguros',
  'ASEGURADORAS.AUDITORIA.FILTER': 'Filtrar Auditoría de Seguros',
  'ASEGURADORAS.AUDITORIA.EXPORT': 'Exportar Auditoría de Seguros',
  'ADMISSIONS.REQUESTS.VIEW': 'Ver Solicitudes de Admisión',
  'ADMISSIONS.REQUESTS.CREATE': 'Crear Solicitudes de Admisión',
  'ADMISSIONS.REQUESTS.FILTER': 'Filtrar Solicitudes de Admisión',
  'ADMISSIONS.REQUESTS.APPROVE': 'Aprobar Solicitudes de Admisión',
  'DEATH_CERTIFICATES.RECORDS.VIEW': 'Ver Certificados de Defunción',
  'DEATH_CERTIFICATES.RECORDS.DETAIL': 'Ver Detalles de Certificados',
  'DEATH_CERTIFICATES.RECORDS.EDIT': 'Editar Certificados de Defunción',
  'DEATH_CERTIFICATES.RECORDS.DELETE': 'Eliminar Certificados de Defunción',
  'DEATH_CERTIFICATES.RECORDS.FILTER': 'Filtrar Certificados de Defunción',
  'STORAGE.DASHBOARD.VIEW': 'Ver Dashboard de Almacenamiento',
  'STORAGE.DASHBOARD.FOLDERS': 'Ver Carpetas',
  'STORAGE.DASHBOARD.UPLOAD': 'Subir Archivos',
  'STORAGE.DASHBOARD.CHARTS': 'Ver Gráficos de Almacenamiento',
  'PATIENTS.CREATE': 'Crear Pacientes',
  'PATIENTS.LIST.VIEW': 'Ver Lista de Pacientes',
  'ADMISSIONS.HOSPITALIZED.VIEW': 'Ver Internamiento',
  'ADMISSIONS.INTENSIVE_CARE_UNIT.VIEW': 'Ver UCI',
  'ADMISSIONS.CREATE': 'Crear Admisión',
};

// ----------------------------------------------------------------------
// Mapeo de rutas a permisos requeridos
// ----------------------------------------------------------------------

export const ROUTE_PERMISSIONS = {
  
  '/medicore': ['DASHBOARD.STATS.VIEW'],
  '/medicore/ejemplo': ['DASHBOARD.STATS.VIEW'], // Página de ejemplo

  // === GESTIÓN DE PACIENTES ===
  // Admisiones y pacientes
  '/medicore/admissions': ['ADMISSIONS.REQUESTS.VIEW'],
  '/patient/new': ['ADMISSIONS.CREATE'], // Registrar admisión
  '/patient/list': ['PATIENTS.LIST.VIEW'], // Lista de pacientes

  // Emergencias y unidades especializadas
  '/medicore/emergency/editor': ['DEATH_CERTIFICATES.RECORDS.VIEW'], // Emergencias
  '/medicore/hospitalized': ['ADMISSIONS.HOSPITALIZED.VIEW'], // Internamiento
  '/medicore/intensiveCareUnit': ['ADMISSIONS.INTENSIVE_CARE_UNIT.VIEW'], // UCI

  // Facturación de pacientes
  '/medicore/patientInvoice/root': ['BILLING.INVOICES.VIEW'],
  '/medicore/patientInvoice/list': ['BILLING.INVOICES.VIEW'],
  '/medicore/patientInvoice/new': ['BILLING.INVOICES.CREATE'],

  // Enfermería
  '/medicore/nurse/root': ['NURSING.SHIFTS.START_SHIFT'],
  '/medicore/nurse/shifts': ['NURSING.SHIFTS.START_SHIFT'],
  '/medicore/nurse/requestproducts': ['NURSING.PRODUCT_REQUEST.VIEW'],

  // Servicios médicos y defunciones
  '/medicore/laboratories': ['MEDICAL_SERVICES.REQUESTS.VIEW'],
  '/medicore/deaths': ['DEATH_CERTIFICATES.RECORDS.VIEW'],
  '/medicore/admissionRequests': ['ADMISSIONS.REQUESTS.VIEW'],

  // === CONSULTAS MÉDICAS ===
  '/medicore/appointmentCalendar': ['APPOINTMENTS.CALENDAR.VIEW'],
  '/medicore/consultingRooms': ['APPOINTMENTS.CALENDAR.VIEW'],
  '/medicore/consultingRoomsRent': ['ROOMS.VIEW'],

  // === ADMINISTRACIÓN ===
  // Habitaciones/Espacios
  '/medicore/rooms': ['ROOMS.VIEW'],
  '/medicore/rooms/root': ['ROOMS.VIEW'],
  '/medicore/rooms/new': ['ROOMS.REGISTER.CREATE'],
  '/medicore/rooms/list': ['ROOMS.EXISTING.VIEW'],

  // Catálogo de servicios médicos
  '/medicore/medicalServiceCatalog': ['CATALOG.MEDICAL_SERVICES.VIEW'],
  '/medicore/medicalServiceCatalog/root': ['CATALOG.MEDICAL_SERVICES.VIEW'],

  // === GESTIÓN DE INVENTARIO ===
  // Inventario principal
  '/medicore/inventory/statistics': ['INVENTORY.STOCK.VIEW'],
  '/medicore/inventory/list': ['INVENTORY.STOCK.VIEW'],
  '/medicore/inventory/warehouse': ['INVENTORY.WAREHOUSES.VIEW'],
  '/medicore/inventory/listMedicalOrder': ['INVENTORY.ORDERS.VIEW'],
  '/medicore/inventory/listExpendableMaterials': ['INVENTORY.PRODUCTS.VIEW'],

  // Órdenes de compra
  '/medicore/inventory/purchaseOrder': ['INVENTORY.PURCHASE_ORDERS.VIEW'],
  '/medicore/inventory/purchaseOrder/root': ['INVENTORY.PURCHASE_ORDERS.VIEW'],
  '/medicore/inventory/purchaseOrder/listPurchaseOrder': ['INVENTORY.PURCHASE_ORDERS.VIEW'],
  '/medicore/inventory/purchaseOrder/newPurchaseOrder': ['INVENTORY.PURCHASE_ORDERS.CREATE'],

  // Requisiciones
  '/medicore/inventory/requisition/listRequisition': ['INVENTORY.REQUISITION.CREATE'],

  // Productos y proveedores
  '/medicore/inventory/listProduct': ['INVENTORY.PRODUCTS.VIEW'],
  '/medicore/inventory/listProvider': ['INVENTORY.PROVIDERS.VIEW'],
  '/medicore/inventory/listCategory': ['INVENTORY.CATEGORIES.VIEW'],

  // Despachos
  '/medicore/inventory/dispatch': ['INVENTORY.DISPATCH.VIEW'],
  '/medicore/inventory/dispatch/root': ['INVENTORY.DISPATCH.VIEW'],
  '/medicore/inventory/dispatch/statistics': ['INVENTORY.DISPATCH.VIEW'],
  '/medicore/inventory/dispatch/dispatchProduct': ['INVENTORY.DISPATCH.VIEW'],
  '/medicore/inventory/dispatch/dispatchWarehouse': ['INVENTORY.DISPATCH.VIEW', 'ROOMS.VIEW'],

  // === CONTABILIDAD ===
  '/medicore/finance/accounts/list': ['ACCOUNTING.ACCOUNTS.VIEW'],
  '/medicore/finance/journal/list': ['ACCOUNTING.ENTRIES.VIEW'],
  '/medicore/finance/checks/list': ['ACCOUNTING.CHECKS.VIEW'],
  '/medicore/finance/pos': ['ACCOUNTING.POS.VIEW'],
  '/medicore/finance/entry/root': ['ACCOUNTING.ENTRIES.VIEW'],
  '/medicore/finance/entry/new': ['ACCOUNTING.ENTRIES.CREATE'],
  '/medicore/finance/entry/list': ['ACCOUNTING.ENTRIES.VIEW'],
  '/medicore/finance/fixed-assets': ['ACCOUNTING.FIXED_ASSETS.VIEW'],
  '/medicore/finance/loans': ['ACCOUNTING.FIXED_ASSETS.VIEW'],
  '/medicore/finance/invoices/new': ['BILLING.INVOICES.CREATE'],
  '/medicore/finance/invoices/list': ['BILLING.INVOICES.VIEW'],
  '/medicore/finance/payroll': ['ACCOUNTING.FIXED_ASSETS.VIEW'],
  '/medicore/finance/petty-cash': ['ACCOUNTING.FIXED_ASSETS.VIEW'],
  '/medicore/finance/report': ['ACCOUNTING.ENTRIES.VIEW'],

  // === SEGUROS ===
  '/medicore/insurance/providers/root': ['SEGUROS.PROVEEDORES.VIEW'],
  '/medicore/insurance/providers/list': ['SEGUROS.PROVEEDORES.VIEW'],
  '/medicore/insurance/authorizations/list': ['ASEGURADORAS.AUDITORIA.VIEW'],
  '/medicore/insurance/audit/root': ['ASEGURADORAS.AUDITORIA.VIEW'],
  '/medicore/insurance/audit/list': ['ASEGURADORAS.AUDITORIA.VIEW'],


  // Gestión de personal
  '/medicore/humanResources/root': ['EMPLOYEES.LIST.VIEW'],
  '/medicore/humanResources/employees/list': ['EMPLOYEES.LIST.VIEW'],
  '/medicore/humanResources/doctors/list': ['EMPLOYEES.LIST.VIEW'],
  '/medicore/humanResources/departments': ['EMPLOYEES.DEPARTMENTS.VIEW'],

  // Vacantes
  '/medicore/humanResources/jobPositions/root': ['RECURSOS_HUMANOS.VACANTES.VIEW'],
  '/medicore/jobPositions': ['RECURSOS_HUMANOS.VACANTES.VIEW'],
  '/medicore/jobPositions/new': ['RECURSOS_HUMANOS.VACANTES.CREATE'],

  // Solicitudes de empleados
  '/medicore/employeeRequest/request': ['RECURSOS_HUMANOS.SOLICITUDES.VIEW'],

  // === CONFIGURACIÓN ===
  '/medicore/configuration/root': ['ACCOUNTING.ACCOUNTS.VIEW'], // Parámetros del sistema
  '/medicore/configuration/equipmentCategory/list': ['INVENTORY.CATEGORIES.VIEW'],
  '/medicore/configuration/doctorFeesCatalog/list': ['CATALOG.MEDICAL_SERVICES.VIEW'],
  '/medicore/configuration/doctorServicesCatalog/list': ['CATALOG.MEDICAL_SERVICES.VIEW'],
  '/medicore/configuration/doctorSpeciality/list': ['MASTER'],
  '/medicore/configuration/dynamicAccounting/root': ['ACCOUNTING.ACCOUNTS.VIEW'],

  // === MESA DE AYUDA ===
  '/medicore/userManagement/list': ['MASTER'],
  '/medicore/userManagement/rolesPermissions': ['MASTER'],
};

// ----------------------------------------------------------------------
// Funciones de utilidad para permisos
// ----------------------------------------------------------------------

export const hasSpecialRole = (user) => {

  if (user?.currentRol?.rolName?.toLowerCase() === 'master') {
    return true;
  }


  if (user?.roles) {
    return user.roles.some((role) => role.toLowerCase() === 'master');
  }

  return false;
};


export const hasPermission = (user, permission) => {

  if (hasSpecialRole(user)) return true;

  if (!user?.permissions || !permission) return false;

  return user.permissions.includes(permission);
};


export const hasAnyPermission = (user, permissions) => {
  if (hasSpecialRole(user)) return true;

  if (!permissions) return false;

  const permissionArray = Array.isArray(permissions) ? permissions : [permissions];

  return permissionArray.some((permission) => hasPermission(user, permission));
};


export const hasAllPermissions = (user, permissions) => {

  if (hasSpecialRole(user)) return true;

  if (!permissions) return false;

  const permissionArray = Array.isArray(permissions) ? permissions : [permissions];

  return permissionArray.every((permission) => hasPermission(user, permission));
};


export const canAccessRoute = (user, route) => {
  if (hasSpecialRole(user)) return true;

  const requiredPermissions = ROUTE_PERMISSIONS[route];


  if (!requiredPermissions || requiredPermissions.length === 0) return false;

  return hasAnyPermission(user, requiredPermissions);
};


export const filterNavItemsByPermissions = (user, navItems) => {
  if (hasSpecialRole(user)) return navItems;


  if (!user || !user.permissions) return [];

  return navItems
    .map((section) => ({
      ...section,
      items: section.items
        .filter((item) => {
          if (item.children) {
            const filteredChildren =
              filterNavItemsByPermissions(user, [
                {
                  ...section,
                  items: item.children,
                },
              ])[0]?.items || [];

            return filteredChildren.length > 0;
          }

         
          return canAccessRoute(user, item.path);
        })
        .map((item) => {
         
          if (item.children) {
            const filteredChildren =
              filterNavItemsByPermissions(user, [
                {
                  ...section,
                  items: item.children,
                },
              ])[0]?.items || [];

            return {
              ...item,
              children: filteredChildren,
            };
          }

          return item;
        }),
    }))
    .filter((section) => section.items.length > 0); 
};


export const getPermissionDescription = (permission) =>
  PERMISSION_ELEMENTS[permission] || permission;


export const groupPermissionsByCategory = (permissions) => {
  const grouped = {};

  permissions.forEach((permission) => {
    const category = permission.split('.')[0];
    if (!grouped[category]) {
      grouped[category] = [];
    }
    grouped[category].push(permission);
  });

  return grouped;
};


export const isValidPermission = (permission) =>
  typeof permission === 'string' && permission.includes('.');


export const debugPermissions = (user, route = null) => {
  const debugInfo = {
    timestamp: new Date().toISOString(),
    user: {
      isAuthenticated: !!user,
      userId: user?.userId || 'N/A',
      username: user?.username || 'N/A',
      roles: user?.roles || [],
      permissionsCount: user?.permissions?.length || 0,
      isMaster: hasSpecialRole(user),
    },
    permissions: {
      userPermissions: user?.permissions || [],
      groupedPermissions: user?.permissions ? groupPermissionsByCategory(user.permissions) : {},
    },
  };

  if (route) {
    debugInfo.route = {
      route,
      requiredPermissions: ROUTE_PERMISSIONS[route] || [],
      canAccess: canAccessRoute(user, route),
      hasMapping: !!ROUTE_PERMISSIONS[route],
    };
  }

  return debugInfo;
};


export const logPermissionDebug = (user, route = null) => {
  const debug = debugPermissions(user, route);
  return debug;
};
export const isMasterUser = (user) => {
  if (user?.currentRol?.rolName?.toLowerCase() === 'master') {
    return true;
  }

  if (user?.roles) {
    return user.roles.some((role) => role.toLowerCase() === 'master');
  }

  return false;
};

export const restrictiveFilterNavigation = (user, navItems) => {
  if (isMasterUser(user)) {
    return navItems;
  }

  if (!user || !user.permissions || user.permissions.length === 0) {
    return [];
  }
  return filterNavItemsByPermissions(user, navItems);
};
